@if (pageInfo$|async; as pageInfo) {
  @if (pageInfo.type === 'STORYBLOK_PAGE' || pageInfo.type === 'NOT_FOUND') {
    @if (storyblok) {
      <ng-template [ndcDynamicInputs]="storyblok?.story?.content"
                   [ngComponentOutlet]="getStoryblokComponents(storyblok?.story?.content.component)"/>
    }
  }
  @if (pageInfo.type === 'PRODUCT_PAGE') {
    <app-product [pageInfo]="pageInfo"/>
  }
  @if (pageInfo.type === 'LIST_PAGE') {
    <app-search-page-dynamic [pageInfo]="pageInfo"/>
  }
} @else {
  <app-loading-icon class="loading-fullscreen"/>
}

<ng-template #loading>
  <app-loading-icon class="loading-fullscreen"/>
</ng-template>
